import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function MedjunarodneOrganizacijePM() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Međunarodne organizacije" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Međunarodne organizacije</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Međunarodne organizacije
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong>{" "}
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Predmet Međunarodne organizacije ima za cilj da studentima
                master studija omogući detaljnije proučavanje međunarodnih
                organizacija kao sve značajnijih subjekata međunarodnog prava
                ali i detaljniji uvid u pravo međunarodnih organizacija. U
                nastavi navedenog predmeta posebna pažnja poklanjat će se
                Ujedinjenim nacijama kao najznačajnijoj univerzalnoj
                međunarodnoj organizaciji današnjice kao i pravo Ujedinjenih
                nacija te odnosu toga prava s opštim međunarodnopravnim
                sistemom. Znanja o Evropskoj uniji stečena na osnovnim studijama
                na ovom predmetu biće proširena i studenti će steći kompletnija
                znanja o Evropskoj uniji.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Savladavanjem gradiva i nakon položenog ispita studenti će biti
                sposobni: definisati pravne pojmove i objasniti pravne institute
                povezane s međunarodnim organizacijama i prepoznati njihovu
                povezanost i uklopljenost u sistem međunarodnog prava;
                definisati i objasniti organe međunarodnih organizacija a
                naročito Ujedinjenih nacija i Evropske unije kao i njihove
                nadležnosti; objasniti međunarodne organizacije kao garanta
                stabilnosti svjetskog poretka i mira; primijeniti relevantne
                međunarodnopravne norme na konkretne primjere iz međunarodne
                prakse; da stečena znanja na budućim poslovima primijene
                naročito u procesu evropskih integracija.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Izvori prava međunarodnih organizacija; Pojam međunarodne
                organizacije; Razvoj međunarodnih organizacija; Transnacionalne
                organizacije; Klasifikacija međunarodnih organizacija; Pravni
                subjektivitet međunarodne organizacije; Međunarodna organizacija
                kao pravno lice i kao subjekt međunarodnog prava; Privilegije i
                imuniteti; Sposobnost zaključivanja ugovora; Jurisdikcija;
                Naddržavna obilježja međunarodnih organizacija; Finansiranje
                međunarodne organizacije; Članstvo u međunarodnim
                organizacijama; Osobine članstva; Položaj članica; Učlanjenje
                Suspenzija; Prestanak članstva; Pridruživnje trećih država;
                Struktura međunarodne organizacije: Najviši organ izvršni organ
                pomoćni organi administrativni organi autonomni organi; Odluke
                međunarodnih organizacija; Vrste odluka; Obavezne odluke;
                Preporuke; Proces odlučivanja; Izvršavanje odluka; Međunarodna
                organizacija i rješavanje sporova; Promjena u ustrojstvu i
                nestanak međunarodne organizacije; Sistem Ujedinjenih Nacija;
                Specijalizovane ustanove Una i organizacije povezane sa UN;
                Evropske organizacije: Evropska Unija Savjet Evrope Organizacija
                za evropsku bezbjednost i saradnju.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Osnovni oblici rada na predmetu su: predavanja i vježbe,
                samostalni rad (seminarski rad), terenska nastava, seminari i
                radionice, upoznavanje studenata sa praksom međunarodnih
                organizacija i sudova.
              </p>
              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>4P + 2V</td>
                    <td>
                      Izvori prava međunarodnih organizacija; Pojam međunarodne
                      organizacije;
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>4P + 2V</td>
                    <td>
                      Razvoj međunarodnih organizacija; Transnacionalne
                      organizacije; Klasifikacija međunarodnih organizacija;
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>4P + 2V</td>
                    <td>
                      Pravni subjektivitet međunarodne organizacije; Međunarodna
                      organizacija kao pravno lice i kao subjekt međunarodnog
                      prava;
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>4P + 2V</td>
                    <td>
                      Privilegije i imuniteti; Sposobnost zaključivanja ugovora;
                      Jurisdikcija;
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>4P + 2V</td>
                    <td>
                      Naddržavna obilježja međunarodnih organizacija;
                      Finansiranje međunarodne organizacije;
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>Kolokvijum I</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>4P + 2V</td>
                    <td>
                      Članstvo u međunarodnim organizacijama; Osobine članstva;
                      Položaj članica; Učlanjenje Suspenzija; Prestanak
                      članstva; Pridruživnje trećih država;
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>4P + 2V</td>
                    <td>
                      Struktura međunarodne organizacije: Najviši organ izvršni
                      organ pomoćni organi administrativni organi autonomni
                      organi;
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>4P + 2V</td>
                    <td>Odluke međunarodnih organizacija; Vrste odluka</td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>4P + 2V</td>
                    <td>
                      Obavezne odluke; Preporuke; Proces odlučivanja;
                      Izvršavanje odluka;
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>4P + 2V</td>
                    <td>Međunarona organizacija i rješavanje sporova;</td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>Kolokvijum II</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>4P + 2V</td>
                    <td>
                      Promjena u ustrojstvu i nestanak međunarodne organizacije
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>4P + 2V</td>
                    <td>
                      Sistem Ujedinjenih Nacija; Specijalizovane ustanove Una i
                      organizacije povezane sa UN;
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>4P + 2V</td>
                    <td>
                      Evropske organizacije: Evropska Unija Savjet Evrope
                      Organizacija za evropsku bezbjednost i saradnju.
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 6 č / 4.3h</td>
                            <td>Ukupno: 120 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 4 č / 3.00h</td>
                            <td>Nastava + završni ispit: 90 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 1.3h</td>
                            <td>Priprema i ovjera semestra: 9 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 21 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default MedjunarodneOrganizacijePM;
